import { RDEqipEligibilityLandControl } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { EqipLandControlTaskEditor } from './EqipLandControlTaskEditor'

export const RDEqipEligibilityLandControlResourceDetailFeature: ResourceDetailFeature<RDEqipEligibilityLandControl> =
  {
    traitId: 'eqipEligibilityLandControl',
    TaskEditor: EqipLandControlTaskEditor,
  }
